import { useRef, useState, type FormEvent, type ReactNode } from 'react';
import { Button } from '../primitives/index.js';

export function ChatComposer(props: {
  busy?: boolean;
  className?: string;
  disabled?: boolean;
  initialValue?: string;
  onSend: (value: string) => Promise<boolean>;
  placeholder?: string;
  submitAriaLabel?: string;
  submitDisabled?: boolean;
  submitLabel?: ReactNode;
}) {
  const [value, setValue] = useState(props.initialValue ?? '');
  const [submitting, setSubmitting] = useState(false);
  const inFlight = useRef(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const content = value.trim();
    if (!content || inFlight.current || props.disabled || props.submitDisabled) return;
    inFlight.current = true;
    setSubmitting(true);
    try {
      // A rejected send keeps the user's draft. Only Backend acceptance clears it.
      if (await props.onSend(content)) setValue('');
    } finally {
      inFlight.current = false;
      setSubmitting(false);
    }
  }

  return (
    <form className={['mira-chat-composer', props.className].filter(Boolean).join(' ')} onSubmit={submit}>
      <input aria-label="Message" disabled={props.disabled || submitting} name="message" onChange={(event) => setValue(event.currentTarget.value)} placeholder={props.placeholder ?? 'Write to Mira…'} value={value} />
      <Button aria-label={props.submitAriaLabel ?? 'Send'} busy={props.busy || submitting} disabled={props.disabled || props.submitDisabled || submitting} type="submit">{props.submitLabel ?? 'Send'}</Button>
    </form>
  );
}
